import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import NavBar from "../Navigation/NavBar";
import { useSelector } from "react-redux";
import MacroCalculatorForm from "./components/MacroInput";
import CalculatorHero from "./components/CalculatorHero";
import httpService from "Root/api/httpService";
import FAQ from "./components/FAQ";
export const safeGetItem = (key, defaultValue) => {
    let val = defaultValue || null;
    const strValue = localStorage.getItem(key);
    if (strValue) {
        try {
            val = JSON.parse(strValue);
        }
        catch (e) {
            // couldnt parse string
        }
    }
    return val;
};
export const RESPONSE_KEY = "prospre/response";
export const MACROS_KEY = "prospre/macros";
const ProsprePage = () => {
    const [response, setResponse] = useState(safeGetItem(RESPONSE_KEY, {}));
    const [isLoading, setIsLoading] = useState(false);
    const [macroInfo, setMacroInfo] = useState({});
    const getMacrosAndSuch = async () => {
        const results = await httpService.get("/api/calories-and-macros/");
        setMacroInfo(results);
    };
    useEffect(() => {
        getMacrosAndSuch();
    }, []);
    const user = useSelector((state) => state.user);
    return (_jsxs("div", { children: [_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data }), _jsx(CalculatorHero, {}), _jsx(MacroCalculatorForm, { setIsLoading: setIsLoading, setResponse: setResponse, profileId: user.profile_id, RESPONSE_KEY: RESPONSE_KEY }), _jsxs("div", { children: [_jsx("h2", { style: { textAlign: "center", fontWeight: "400", marginTop: "64px" }, children: "FAQ" }), _jsx(FAQ, {})] })] }));
};
export default ProsprePage;
